import { NotificationTypes, SafeAny } from '@/common/types';
import { ScoreSet } from '@/modules/score-set/types';
import { axiosInstance } from '@/common/utils';

export const getScoreSetByStudy = async (
  { rootState, state, commit }: SafeAny,
  { sleepStudyID }: { sleepStudyID: string }
) => {
  if (!sleepStudyID) return;

  const url = `${rootState.env.requestUrl.events}/studies/${sleepStudyID}/score-set`;

  state.scoreSet.isLoading = true;
  state.scoreSet.error = undefined;

  try {
    const response = await axiosInstance.get<ScoreSet[]>(url);

    state.scoreSet.isLoading = false;
    state.scoreSet.data = response.data;
  } catch (error: SafeAny) {
    state.scoreSet.isLoading = false;
    state.scoreSet.data = [];

    commit(
      'addNotification',
      {
        i18nTitle: 'errorGetScoreSets',
        i18nDescription: error.message,
        type: NotificationTypes.Error
      },
      { root: true }
    );
  }
};
